import { __awaiter, __generator, __read, __values } from "tslib";
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { checkSubsidy, clearSelectedSubsidies, selectSubsidy, setCheckSubsidyResult, setSubsidiesError, setSubsidiesLoading, setSubsidiesResultsOpen, setSubsidiesState } from './actions';
import { OrderSubsidyInfoDocument } from '@websky/graphql';
import { createClient } from '../../../graphql-client';
import { getOrderId } from '../order/selectors';
import { getSubsidiesResults } from './selectors';
var checkSubsidyRequest = function (orderId, travellers) { return __awaiter(void 0, void 0, void 0, function () {
    var client;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                client = createClient();
                return [4 /*yield*/, client.query({
                        query: OrderSubsidyInfoDocument,
                        fetchPolicy: 'no-cache',
                        variables: {
                            id: orderId,
                            travellers: travellers
                        }
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export function setSubsidies(order) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(setSubsidiesState(order))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function selectSubsidiesByDefault(_a) {
    var subsidiesByTravellers, _b, _c, _d, passengerId, subsidiesBySegments, subsidiesToSelect, _e, _f, _g, segmentId, subsidies, subsidies_1, subsidies_1_1, subsidy, travellerHasOnlyOneSubsidy, subsidiesToSelect_1, subsidiesToSelect_1_1, subsidyToSelect, e_1_1, e_2_1;
    var e_2, _h, e_3, _j, e_4, _k, e_1, _l;
    var payload = _a.payload;
    return __generator(this, function (_m) {
        switch (_m.label) {
            case 0: return [4 /*yield*/, select(getSubsidiesResults)];
            case 1:
                subsidiesByTravellers = _m.sent();
                _m.label = 2;
            case 2:
                _m.trys.push([2, 13, 14, 15]);
                _b = __values(Object.entries(subsidiesByTravellers)), _c = _b.next();
                _m.label = 3;
            case 3:
                if (!!_c.done) return [3 /*break*/, 12];
                _d = __read(_c.value, 2), passengerId = _d[0], subsidiesBySegments = _d[1];
                subsidiesToSelect = [];
                try {
                    for (_e = (e_3 = void 0, __values(Object.entries(subsidiesBySegments))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        _g = __read(_f.value, 2), segmentId = _g[0], subsidies = _g[1];
                        try {
                            for (subsidies_1 = (e_4 = void 0, __values(subsidies)), subsidies_1_1 = subsidies_1.next(); !subsidies_1_1.done; subsidies_1_1 = subsidies_1.next()) {
                                subsidy = subsidies_1_1.value;
                                if (!subsidy.rejectMessage) {
                                    subsidiesToSelect.push({
                                        segmentId: segmentId,
                                        subsidyId: subsidy.id
                                    });
                                }
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (subsidies_1_1 && !subsidies_1_1.done && (_k = subsidies_1.return)) _k.call(subsidies_1);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_j = _e.return)) _j.call(_e);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                travellerHasOnlyOneSubsidy = new Set(subsidiesToSelect.map(function (subsidy) { return subsidy.subsidyId; })).size === 1;
                if (!travellerHasOnlyOneSubsidy) return [3 /*break*/, 11];
                _m.label = 4;
            case 4:
                _m.trys.push([4, 9, 10, 11]);
                subsidiesToSelect_1 = (e_1 = void 0, __values(subsidiesToSelect)), subsidiesToSelect_1_1 = subsidiesToSelect_1.next();
                _m.label = 5;
            case 5:
                if (!!subsidiesToSelect_1_1.done) return [3 /*break*/, 8];
                subsidyToSelect = subsidiesToSelect_1_1.value;
                return [4 /*yield*/, put(selectSubsidy({
                        subsidyId: subsidyToSelect.subsidyId,
                        segmentId: subsidyToSelect.segmentId,
                        passengerId: passengerId
                    }))];
            case 6:
                _m.sent();
                _m.label = 7;
            case 7:
                subsidiesToSelect_1_1 = subsidiesToSelect_1.next();
                return [3 /*break*/, 5];
            case 8: return [3 /*break*/, 11];
            case 9:
                e_1_1 = _m.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 11];
            case 10:
                try {
                    if (subsidiesToSelect_1_1 && !subsidiesToSelect_1_1.done && (_l = subsidiesToSelect_1.return)) _l.call(subsidiesToSelect_1);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 11:
                _c = _b.next();
                return [3 /*break*/, 3];
            case 12: return [3 /*break*/, 15];
            case 13:
                e_2_1 = _m.sent();
                e_2 = { error: e_2_1 };
                return [3 /*break*/, 15];
            case 14:
                try {
                    if (_c && !_c.done && (_h = _b.return)) _h.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
                return [7 /*endfinally*/];
            case 15: return [2 /*return*/];
        }
    });
}
export function checkSubsidies(action) {
    var orderId, orderSubsidyInfo, e_5, gqlError;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 8, , 11]);
                return [4 /*yield*/, put(setSubsidiesLoading(true))];
            case 1:
                _a.sent();
                return [4 /*yield*/, select(getOrderId)];
            case 2:
                orderId = _a.sent();
                return [4 /*yield*/, put(clearSelectedSubsidies())];
            case 3:
                _a.sent();
                return [4 /*yield*/, call(checkSubsidyRequest, orderId, action.payload)];
            case 4:
                orderSubsidyInfo = _a.sent();
                return [4 /*yield*/, put(setCheckSubsidyResult(orderSubsidyInfo.data.OrderSubsidyInfo))];
            case 5:
                _a.sent();
                return [4 /*yield*/, put(setSubsidiesLoading(false))];
            case 6:
                _a.sent();
                return [4 /*yield*/, put(setSubsidiesResultsOpen(true))];
            case 7:
                _a.sent();
                return [3 /*break*/, 11];
            case 8:
                e_5 = _a.sent();
                gqlError = e_5;
                return [4 /*yield*/, put(setSubsidiesError(gqlError['debugMessage'] || gqlError['message']))];
            case 9:
                _a.sent();
                return [4 /*yield*/, put(setSubsidiesLoading(false))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
export function subsidiesSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(setCheckSubsidyResult.toString(), selectSubsidiesByDefault)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(checkSubsidy.toString(), checkSubsidies)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
